import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import ContactForm from '@/components/feature/ContactForm';
import SEOHead from '@/components/feature/SEOHead';
import { Link } from 'react-router-dom';

export default function PolitiqueConfidentialite() {
  return (
    <>
      <SEOHead
        title="Politique de confidentialité | DFPRO Lyon"
        description="Politique de confidentialité et protection des données personnelles de DFPRO Lyon. Conformément au RGPD."
        canonicalUrl="https://depanfenetres-lyon.fr/politique-confidentialite/"
      />
      <Header />

      <main className="pt-20 pb-16">
        <section className="w-full bg-background-100 py-12 md:py-16">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <nav className="flex items-center gap-2 text-xs text-secondary-400 mb-6 flex-wrap">
              <Link to="/" className="hover:text-primary-500 transition-colors">Accueil</Link>
              <i className="ri-arrow-right-s-line w-3 h-3 flex items-center justify-center"></i>
              <span className="text-secondary-500">Politique de confidentialité</span>
            </nav>
            <h1 className="font-heading font-bold text-2xl md:text-4xl text-foreground-800">Politique de confidentialité</h1>
            <p className="mt-3 text-sm text-secondary-500">Dernière mise à jour : juillet 2026</p>
          </div>
        </section>

        <section className="w-full bg-background-50 py-10 md:py-14">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <div className="space-y-8 text-sm text-secondary-500 leading-relaxed">
              <div>
                <h2 className="font-heading font-semibold text-lg text-foreground-800 mb-3">1. Collecte des données personnelles</h2>
                <p>
                  Conformément au Règlement Général sur la Protection des Données (RGPD), nous collectons uniquement les données personnelles nécessaires au traitement de votre demande de dépannage ou de devis. Les informations collectées via notre formulaire de contact (nom, téléphone, email, ville, message) sont strictement utilisées pour vous recontacter dans le cadre de votre demande d'intervention à Lyon et dans la Métropole de Lyon.
                </p>
              </div>

              <div>
                <h2 className="font-heading font-semibold text-lg text-foreground-800 mb-3">2. Finalité du traitement</h2>
                <p>Les données collectées ont pour finalité :</p>
                <ul className="mt-2 space-y-1 list-disc list-inside">
                  <li>La prise de contact et l'établissement d'un devis gratuit</li>
                  <li>La planification d'une intervention de dépannage</li>
                  <li>Le suivi de votre demande et la facturation le cas échéant</li>
                  <li>L'envoi d'informations relatives à nos services, uniquement si vous y avez consenti</li>
                </ul>
              </div>

              <div>
                <h2 className="font-heading font-semibold text-lg text-foreground-800 mb-3">3. Destinataires des données</h2>
                <p>
                  Les données personnelles collectées sont exclusivement destinées à DF PRO (DFPRO Lyon). Elles ne sont en aucun cas vendues, louées ou cédées à des tiers, sauf obligation légale ou demande judiciaire.
                </p>
              </div>

              <div>
                <h2 className="font-heading font-semibold text-lg text-foreground-800 mb-3">4. Durée de conservation</h2>
                <p>
                  Les données sont conservées pendant une durée de 3 ans à compter du dernier contact avec vous, conformément aux recommandations de la CNIL pour les données de prospection commerciale. Les données de facturation sont conservées pendant 10 ans conformément aux obligations comptables et fiscales.
                </p>
              </div>

              <div>
                <h2 className="font-heading font-semibold text-lg text-foreground-800 mb-3">5. Vos droits</h2>
                <p>Conformément au RGPD, vous disposez des droits suivants sur vos données personnelles :</p>
                <ul className="mt-2 space-y-1 list-disc list-inside">
                  <li><strong>Droit d'accès :</strong> vous pouvez demander à consulter les données que nous détenons à votre sujet</li>
                  <li><strong>Droit de rectification :</strong> vous pouvez demander la correction de données inexactes</li>
                  <li><strong>Droit à l'effacement :</strong> vous pouvez demander la suppression de vos données</li>
                  <li><strong>Droit d'opposition :</strong> vous pouvez vous opposer au traitement de vos données</li>
                  <li><strong>Droit à la portabilité :</strong> vous pouvez récupérer vos données dans un format structuré</li>
                </ul>
                <p className="mt-2">
                  Pour exercer vos droits, contactez-nous par email à <a href="mailto:lyon@dfpro.fr" className="text-primary-500 hover:text-primary-600">lyon@dfpro.fr</a> ou par courrier à l'adresse du siège social : DF PRO, 100 route de Nîmes, 30132 Caissargues.
                </p>
              </div>

              <div>
                <h2 className="font-heading font-semibold text-lg text-foreground-800 mb-3">6. Cookies</h2>
                <p>
                  Ce site n'utilise pas de cookies de suivi ou de publicité. Seuls des cookies techniques strictement nécessaires au fonctionnement du site peuvent être déposés. Vous pouvez configurer votre navigateur pour refuser les cookies.
                </p>
              </div>

              <div>
                <h2 className="font-heading font-semibold text-lg text-foreground-800 mb-3">7. Sécurité</h2>
                <p>
                  Nous mettons en œuvre toutes les mesures techniques et organisationnelles appropriées pour garantir la sécurité et la confidentialité de vos données personnelles, notamment pour empêcher qu'elles soient déformées, endommagées ou que des tiers non autorisés y aient accès.
                </p>
              </div>

              <div>
                <h2 className="font-heading font-semibold text-lg text-foreground-800 mb-3">8. Réclamation</h2>
                <p>
                  Si vous estimez que le traitement de vos données personnelles n'est pas conforme à la réglementation, vous pouvez introduire une réclamation auprès de la CNIL (Commission Nationale de l'Informatique et des Libertés) — <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" className="text-primary-500 hover:text-primary-600">www.cnil.fr</a>.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="w-full bg-background-100 py-12 md:py-16">
          <div className="max-w-2xl mx-auto px-4 md:px-6">
            <h2 className="font-heading font-semibold text-lg md:text-xl text-foreground-800 text-center mb-8">Exercer vos droits — Contactez-nous</h2>
            <div className="bg-background-50 rounded-lg p-6 md:p-8 border border-background-200">
              <ContactForm />
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}